import { RavenModal, RavenButton } from '@ravenpay/raven-bank-ui';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux'; // Make sure to import the correct action
import {
	getAllAddress,
	handleAddressAction,
} from '../../../../../redux/bankbox';
import './styles/index.css';

interface ConfirmModalProps {
	isOpen: boolean;
	onClose?: () => void;
	onFinish?: () => void;
	details?: {
		email: string;
		action: 'confirm' | 'reject' | 'revoke';
		id?: string;
		status?: number;
		type: 'address';
	};
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
	isOpen,
	onClose,
	onFinish,
	details,
}) => {
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);

	if (!isOpen || !details) return null;

	const { email, action, id, status } = details;

	const getStatusFromAction = (
		action: 'confirm' | 'reject' | 'revoke'
	): number => {
		switch (action) {
			case 'confirm':
				return 1;
			case 'reject':
				return 4;
			case 'revoke':
				return 2;
			default:
				return 0;
		}
	};

	const actionLabel = {
		confirm: 'Verify',
		reject: 'Reject',
		revoke: 'Revoke',
	}[action];

	const handleAction = async () => {
		setLoading(true);

		try {
			const result = await dispatch(handleAddressAction({ action, email }));

			if (result?.payload?.status === 'fulfilled') {
				const updateResult = await dispatch(getAllAddress({}));

				if (updateResult?.payload?.status === 'success') {
					onFinish?.();
				}
			} else {
				// console.error('address Action failed:', result?.payload?.message);
				onFinish?.();
			}
		} catch (error) {
			// console.error('An error occurred while processing the action:', error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<RavenModal
			onBtnClick={() => {}}
			className="session"
			visble={isOpen}
			onClose={onClose}
			loading={loading}
		>
			<div className="change-request-status-modal-wrap">
				<div className="title">
					<p
						style={{
							fontSize: '2rem',
							marginBottom: '1.5rem',
							fontWeight: '600',
						}}
					>
						Proceed {actionLabel}
					</p>
					<p
						style={{
							fontSize: '1.45rem',
							fontWeight: '400',
							lineHeight: '2.4rem',
							color: 'rgba(103, 103, 103, 1)',
						}}
					>
						Are you sure to reject this <strong>{actionLabel}</strong>{' '}
						Verification? Kindly note this action cannot be undone
					</p>
				</div>

				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						gap: '1rem',
						marginTop: '2rem',
					}}
				>
					<div
						style={{
							backgroundColor: 'rgba(247, 248, 247, 1)',
							display: 'flex',
							width: '100%',
							padding: '2rem',
							gap: '2rem',
						}}
					>
						<RavenButton
							color="deep-green-dark"
							label="No, Cancel"
							className="reusable-btn-outline-classname-cancel"
							size="big"
							onClick={onClose}
							style={{ width: '100%' }}
						/>
						<RavenButton
							size="big"
							style={{ width: '100%' }}
							className="btn"
							color="deep-green-dark"
							label={`Yes, ${actionLabel}`}
							onClick={handleAction}
							loading={loading}
							disabled={getStatusFromAction(action) === status}
						/>
					</div>
				</div>
			</div>
		</RavenModal>
	);
};

export default ConfirmModal;
